<template lang="pug">
  .PostContent.article-content
    PostContentHeader(:data="postData")
    .article-content__text-section.page-container
      .article-content__left-aside
        #left-aside-subscribe
          .article-content__left-aside-subscribe(v-if="subscribe")
            .is-h6__title.article-content__left-aside-subscribe-title Subscribe to Our Newsletter
            p.small-text Get the latest in farmland investing and selling farmland
            BaseButton(
              color="primary",
              tag="router-link"
              :to="{ hash: 'what-are-you-interested-in' }",
              replace,
              aria-label="Click on Subscribe to Our Newsletter"
            ) Subscribe
          .article-content__left-aside-sharing
            .is-h6__title.article-content__left-aside-sharing-title Share:
            BaseShare.mb-0(
              :url="fullPath",
              :title="postData.name",
              :description="postData.seo_description",
            )
      .article-content__markdown-container
        PostContentMarkdown#scroll-content(
          :data="postData"
        )
        PostContentTags.article-content__tags(
          :data="postData"
          v-if="hasTags && postData.tags.length"
        )
        PostContentAuthor.article-content__author-section(
          v-if="postData.author.first_name && subscribe"
          :data="postData"
        )
        .article-content__mobile-share
          .is-h6__title.article-content__mobile-share-title Share:
          BaseShare.article-content__mobile-share-base-share(
            :url="fullPath",
            :title="postData.name",
            :description="postData.seo_description",
          )
    PostContentAlsoLike.article-content__also-like(
      v-if="postData.youMightAlsoLikePosts.length"
      :data="postData"
      :show-thumbnail-category="showThumbnailCategory"
    )
</template>

<script>
import CONFIG from 'Config';
import HcSticky from 'hc-sticky'; // Sticky menu
import BaseShare from 'Components/Base/BaseShare';
import BaseButton from 'Components/Base/BaseButton';
import { BasePostClass } from 'Classes';
import PostContentHeader from './PostContentHeader';
import PostContentAuthor from './PostContentAuthor';
import PostContentTags from './PostContentTags';
import PostContentAlsoLike from './PostContentAlsoLike';
import PostContentMarkdown from './PostContentMarkdown';

export default {
  name: 'PostContent',
  components: {
    PostContentHeader,
    BaseShare,
    PostContentAuthor,
    PostContentTags,
    PostContentAlsoLike,
    PostContentMarkdown,
    BaseButton,
  },
  props: {
    postData: BasePostClass,
    subscribe: Boolean,
    showThumbnailCategory: Boolean,
    hasTags: Boolean,
  },
  data() {
    return {
      stick: null,
    };
  },
  computed: {
    fullPath() {
      return `${CONFIG.urls.frontend}${this.$route.fullPath}`;
    },
  },
  watch: {
    '$route.path': {
      handler() {
        if (!this.stick) this.initStick();
        else this.stick.refresh();
      },
      immediate: true,
    },
  },
  mounted() {
    this.initStick();
  },
  beforeDestroy() {
    if (this.stick) this.stick.destroy();
  },
  methods: {
    initStick() {
      this.stick = new HcSticky('#left-aside-subscribe', {
        stickTo: '#scroll-content',
        top: 90,
        innerTop: -110,
        stickyClass: 'is--active-sticky',
      });
    },
  },
};
</script>

<style lang="sass" scoped>
@import '~Styles/_variables'
.article-content
  margin-bottom: 80px
  @media screen and (max-width: 767px)
    margin-bottom: 70px
  &__text-section
    flex-direction: row
  &__tags
    margin: 50px 0
    margin-bottom: 40px
    @media screen and (max-width: 767px)
      margin: 35px -5px
  &__left-aside
    width: 100%
    max-width: 166px
    flex-shrink: 0
    margin-right: 30px
    @media screen and (max-width: 767px)
      display: none
  &__left-aside-subscribe
    opacity: 0
    transition: opacity 0.2s ease-in-out
    margin-bottom: 50px
  &__left-aside-subscribe-title
    margin-bottom: 10px
  &__left-aside-sharing
    opacity: 0
    transition: opacity 0.2s ease-in-out
  &__left-aside-sharing-title
    margin-bottom: 15px
  .is--active-sticky
    .article-content__left-aside-subscribe,
    .article-content__left-aside-sharing
      transition: opacity 0.2s ease-in-out
      opacity: 1
  &__mobile-share
    margin-top: 35px
    margin-bottom: 0
    @media screen and (min-width: 768px)
      display: none
  &__mobile-share-title
    margin-bottom: 15px
  &__mobile-share-base-share
    margin-bottom: 0
  &__also-like
    width: 100%
    max-width: 1170px
    padding: 0 15px
    margin: 0 auto
    min-height: 470px
    margin-top: 80px
    @media screen and (max-width: 767px)
      margin-top: 70px
  &__markdown-container
    width: 100%
    max-width: 750px
    @media screen and (max-width: 767px)
      max-width: 100%
  &__author-section
    width: 100%
    margin-top: 50px
    @media screen and (max-width: 767px)
      margin-top: 35px
      margin-bottom: 35px
</style>
